export const BRAND_LOGO_VARIANTS = ["icon", "typography", "monogram", "lockup"] as const;

export const BRAND_LOGO_VARIANT_COUNT = BRAND_LOGO_VARIANTS.length;
